import { withTheme } from '@mui/styles';
import styled from 'styled-components';

import LoadingButton from '@components/atoms/loadingButton';

export const AvailableButtonStyle = withTheme(styled(LoadingButton)`
  && {
    font-size: ${(props: any) => props.fontSize || '24px'};
    font-weight: 500;
    background: white;
    height: ${(props: any) => (props.height || props.isFooter ? '40px' : '60px')};
    color: ${(props: any) => props.theme.palette.primary.main};
    :hover {
      opacity: 0.9;
      background-color: white;
    }
    &&.Mui-disabled {
      color: #0000001f;
    }
  }
`);
